var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClockWithDoc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1663 10.4C13.455 10.4 14.4997 9.86274 14.4997 9.2C14.4997 8.53726 13.455 8 12.1663 8C10.8777 8 9.83301 8.53726 9.83301 9.2C9.83301 9.86274 10.8777 10.4 12.1663 10.4Z",
    stroke: "#D3D5D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4997 11C14.4997 11.6627 13.455 12.2 12.1663 12.2C10.8777 12.2 9.83301 11.6627 9.83301 11",
    stroke: "#D3D5D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4997 12.7998C14.4997 13.4625 13.455 13.9998 12.1663 13.9998C10.8777 13.9998 9.83301 13.4625 9.83301 12.7998",
    stroke: "#D3D5D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83301 9.2002V12.8002",
    stroke: "#D3D5D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 9.2002V12.8002",
    stroke: "#D3D5D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49978 12C6.56254 11.9998 5.64424 11.7361 4.84962 11.2391C4.055 10.7421 3.41607 10.0318 3.00571 9.18919C2.59535 8.34657 2.43009 7.40557 2.52877 6.47354C2.62746 5.54151 2.98612 4.65598 3.56384 3.91797C4.14156 3.17996 4.91507 2.61919 5.79615 2.29962C6.67722 1.98006 7.63038 1.91456 8.54688 2.11062C9.46339 2.30667 10.3063 2.75637 10.9796 3.40843C11.6528 4.06048 12.1292 4.88863 12.3544 5.7984",
    stroke: "#D3D5D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50033 4.33301V6.99967L5.16699 7.99967",
    stroke: "#D3D5D9",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClockWithDoc);
export default __webpack_public_path__ + "static/media/clock_with_doc.45ce4545235293f52ecfcb9eb29b02be.svg";
export { ForwardRef as ReactComponent };